import { render, staticRenderFns } from "./shop-performance.vue?vue&type=template&id=207dc369&scoped=true&"
import script from "./shop-performance.vue?vue&type=script&lang=js&"
export * from "./shop-performance.vue?vue&type=script&lang=js&"
import style0 from "./shop-performance.vue?vue&type=style&index=0&id=207dc369&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207dc369",
  null
  
)

export default component.exports